import { render, staticRenderFns } from "./Attestations.vue?vue&type=template&id=66265654&"
import script from "./Attestations.vue?vue&type=script&lang=js&"
export * from "./Attestations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports